import { createFileRoute } from "@tanstack/react-router";
import { EexStatsPage } from "../features/eex/stats/StatsPage";

export const Route = createFileRoute("/eex/stats")({ component: EexStatsPage });
